import type { IApiCurrency } from '@/modules/currenciesModule/types/currencies'

export const apiCurrencies = {
	fetchCurrenciesExchangeRates: async () => {
		const { data } = await apiCommon<{ data: IApiCurrency[] }>('currencies-exchange-rates', { method: 'GET' })
		if (!data) return []
		return data.map((currency: IApiCurrency) => Currency(currency))
	},
}
